import React from "react";

import "./SearchInput.css";

const SearchInput = ({ onChange, value }) => {
    return (
        <div className="search-group">
            <div className="search-icon">
                <img src="/images/search.svg" alt="search" />
            </div>
            <input
                type="search"
                placeholder="Search Agent..."
                onChange={onChange}
                value={value}
            />
        </div>
    );
};

export default SearchInput;
